import type {
  CallableApiConfig,
  CallableApiClient,
  CallableEnvelope,
  RouteTypeMap,
} from '@gh/common/callable-client'
import type { HttpsCallable } from 'firebase/functions'
import { functions } from '@/firebase'
import { traceHttpsCallable } from './sentry'

export function backendClient<TMap extends RouteTypeMap>(
  config: CallableApiConfig<TMap>,
): CallableApiClient<TMap> {
  const callables = new Map<string, HttpsCallable<CallableEnvelope, unknown>>()

  function getCallable(gatewayName: string): HttpsCallable<CallableEnvelope, unknown> {
    let callable = callables.get(gatewayName)
    if (!callable) {
      callable = traceHttpsCallable<CallableEnvelope, unknown>(functions, gatewayName)
      callables.set(gatewayName, callable)
    }
    return callable
  }

  const client = {} as CallableApiClient<TMap>

  for (const methodName of Object.keys(config.routes) as Array<keyof TMap & string>) {
    const route = config.routes[methodName]
    ;(client as Record<string, unknown>)[methodName] = async (data?: unknown) => {
      const result = await getCallable(route.gateway)({
        action: route.action,
        data,
      })
      return result.data
    }
  }

  return client
}
